import styled from 'styled-components';
import { COLOR_WHITE } from '../../../assets/styles/colors';
import { rgba } from 'polished';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div``;

export const ChartTopSC = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .chart-type-switch {
    display: flex;
    width: 300px;
    height: 24px;
    border-radius: 6px;
    box-shadow: inset 0 0 0 1px ${rgba(COLOR_WHITE, 0.1)};

    button {
      height: 24px;
      padding: 0 0 4px 0;
      background: none;
      width: 33.333%;
      border-radius: 6px;
      border: none;
      font-size: 16px;
      font-weight: 600;
      color: ${COLOR_WHITE};
      &.active {
        background-image: linear-gradient(to left, #fab535, #f7931e);
      }
    }

    @media (max-width: 1070px) {
      width: 280px;
    }
  }

  .chart-year-switch {
    min-width: 140px;
    justify-content: flex-end;
    display: flex;
    align-items: center;
    .arrow-wrap {
      padding-left: 16px;
      align-items: center;
      display: flex;
      button {
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: ${rgba(COLOR_WHITE, 0.2)};
        &:first-child {
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
          margin-right: 1px;
        }
        &:last-child {
          margin-left: 1px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
        }
        &:disabled {
          opacity: 0.5;
        }
      }
    }
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: row wrap;
    p {
      width: 100%;
    }
    .chart-type-switch {
      margin-top: 15px;
      width: calc(100% - 140px);
    }
    .chart-year-switch {
      min-width: 140px;
      margin-top: 15px;
    }
  }
`;

export const ChartWrapSC = styled.div`
  padding-top: 30px;
  width: 100%;
  height: 270px;
`;
